// extracted by mini-css-extract-plugin
module.exports = {"container":"FU-z","recos":"GU-z","productCardOverride":"HU-z"};